
import React from 'react';
import { AdminLayout } from '@/components/admin/AdminLayout';
import { CertificatesTemplatesContent } from '@/components/admin/certificates/CertificatesTemplatesContent';

export default function CertificatesTemplates() {
  return (
    <AdminLayout>
      <CertificatesTemplatesContent />
    </AdminLayout>
  );
}
